import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {

  gsap.utils.toArray(".gs-parallax").forEach((section) => {
    gsap.fromTo(section,
      {
        y: 0
      },
      {
        y: 150,
        force3D: true,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          scrub: true,
          start: "top top",
          end: "bottom top"
        },
      }
    );
  });



  gsap.utils.toArray(".gs-move").forEach((el) => {
    gsap.from(el, {
      xPercent: -15,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        scrub: 2.2,

        start: "top bottom",
        end: "top center",

        invalidateOnRefresh: true,
      }
    });
  });





  (() => {
    const elements = document.querySelectorAll('.gs-faded-text');
    if (!elements.length) return;

    elements.forEach((el) => {
      gsap.from(el, {
        opacity: 0,
        y: 50,
        ease: "none",

        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          end: "top 50%",
          scrub: true,
          invalidateOnRefresh: true
        }
      });
    });
  })();


  (() => {
    document.querySelectorAll('.gs-stagger').forEach((el) => {
      const items = el.querySelectorAll(':scope > li');

      if (!items.length) return;

      gsap.set(items, {
        opacity: 0,
        x: -60
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          end: 'bottom 60%',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      items.forEach((item, index) => {
        tl.to(item, {
          opacity: 1,
          x: 0,
          duration: 1,
          ease: 'power2.out'
        }, index * 0.8);
      });
    });
  })();






  (() => {
    const underlineImg = document.querySelectorAll('.underline-reveal');
    const text = document.querySelectorAll('.js-underline-text');

    if (!underlineImg.length && !text.length) return;

    let hasPlayed = false;

    const playAnimations = () => {
      if (hasPlayed) return;
      hasPlayed = true;

      const tl = gsap.timeline();

      // 1️⃣ TEXT fade-in
      if (text.length) {
        tl.fromTo(text,
          {
            opacity: 0,
            y: 8
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.35,
            ease: "power2.out",
            stagger: 0.05
          }
        );
      }

      // 2️⃣ UNDERLINE reveal (mask)
      if (underlineImg.length) {
        tl.fromTo(underlineImg,
          {
            maskSize: "0% 100%",
            WebkitMaskSize: "0% 100%"
          },
          {
            maskSize: "100% 100%",
            WebkitMaskSize: "100% 100%",
            duration: 1.2,
            ease: "power2.out"
          },
          "-=0.1" // lekko nakłada się na fade textu
        );
      }
    };

    const cover = document.querySelector('#cover');

    if (!cover) {
      playAnimations();
      return;
    }

    const check = () => {
      if (!document.body.contains(cover)) {
        playAnimations();
        observer.disconnect();
      }

      const style = window.getComputedStyle(cover);

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.opacity === '0'
      ) {
        playAnimations();
        observer.disconnect();
      }
    };

    const observer = new MutationObserver(check);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

  })();





  (() => {

    const initAnimations = () => {

      const elements = document.querySelectorAll('.js-reval');
      if (!elements.length) return;

      elements.forEach(el => {

        el.classList.remove('invisible');

        const originalText = el.textContent;

        if (!el.querySelector('.char')) {
          el.innerHTML = originalText.replace(/\S/g, "<span class='char'>$&</span>");
        }

        const chars = el.querySelectorAll('.char');

        const animation = gsap.fromTo(chars,
          {
            yPercent: 100,
            opacity: 0,
          },
          {
            yPercent: 0,
            opacity: 1,
            stagger: 0.025,
            duration: 2,
            ease: "elastic.out(1, 0.7)",
            paused: true
          }
        );

        ScrollTrigger.create({
          trigger: el,
          start: "top 85%",
          once: true,
          onEnter: () => animation.play(),
          onEnterSelf: self => {
            if (self.isActive) animation.play();
          }
        });

      });

      // Uwaga: refresh po realnym ustabilizowaniu layoutu jest teraz
      // obsługiwany w src/js/cards.js (document.fonts.ready) oraz
      // src/js/init.js (po carousels()/usunięciu #cover) — listener
      // window.addEventListener('load', ...) który był tutaj wcześniej
      // nigdy się nie wykonywał, bo rejestrował się już PO odpaleniu
      // zdarzenia 'load' (ten blok uruchamia się dopiero po usunięciu
      // #cover, a to dzieje się 250ms po 'load').
    };

    const waitForCover = () => {
      const cover = document.querySelector('#cover');

      // 🔥 jeśli nie ma covera → start od razu
      if (!cover) {
        setTimeout(function() {
          initAnimations();
        }, 1000)
        
        return;
      }

      const check = () => {
        if (!document.body.contains(cover)) {
          initAnimations();
          observer.disconnect();
        }
      };

      const observer = new MutationObserver(check);

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      // fallback (np. opacity hide zamiast remove)
      // const interval = setInterval(() => {
      //   if (!document.body.contains(cover)) {
      //     clearInterval(interval);
      //     initAnimations();
      //     observer.disconnect();
      //   }
      // }, 200);
    };

    waitForCover();

  })();





  (() => {
    const container = document.querySelector('.js-tags');
    if (!container) return;

    const items = container.querySelectorAll('.tag-anim');
    if (!items.length) return;

    gsap.from(items, {
      opacity: 0,
      y: 20,
      scale: 0.9,
      ease: "power2.out",
      stagger: 0.08, // 🔥 kluczowy efekt "jeden po drugim"

      scrollTrigger: {
        trigger: container,
        start: "top 80%",
        toggleActions: "play none none none",
      }
    });
  })();




  (() => {
    const rows = document.querySelectorAll(".js-row");
    if (!rows.length) return;

    rows.forEach((row) => {
      const left = row.querySelector(".js-left");
      const right = row.querySelector(".js-right");

      if (!left || !right) return;

      // 🔹 start state
      gsap.set(left, {
        x: -40,
        opacity: 0
      });

      gsap.set(right, {
        x: 40,
        opacity: 0
      });

      // 🔥 animacja scrollowa
      gsap.to(left, {
        x: 0,
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          trigger: row,
          start: "top 85%",
          end: "top 50%",
          scrub: true
        }
      });

      gsap.to(right, {
        x: 0,
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          trigger: row,
          start: "top 45%",
          end: "top 20%",
          scrub: true
        }
      });
    });
  })();






  window.afterLoadAnims = () => {
    const tl = gsap.timeline();
    tl.from(document.querySelector("#topbar-logo"), {
      duration: 1.6,
      y: 40,
      autoAlpha: 0,
      ease: 'elastic.out(1, .8)',
    }, 0)

    tl.from(document.querySelector("#slogan"), {
      duration: 1.6,
      y: 40,
      autoAlpha: 0,
      ease: 'elastic.out(1, .8)',
    }, '-=1.4')

    tl.from(document.querySelector("#topbar-button"), {
      duration: 1.6,
      y: 40,
      autoAlpha: 0,
      ease: 'elastic.out(1, .8)',
    }, '-=1.4')
  }
});
